import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@mui/material';
import { cross } from '../../../assets';
import { Card } from '@shopify/polaris';

const ErrorDialog: React.FC<ErrorDialogProps> = ({ open, onClose, errorMessage }) => {
    // Convert errorMessage to an array if it's a string
    const errorMessages = Array.isArray(errorMessage) ? errorMessage : [errorMessage];

    return (
        <Modal open={open} onClose={onClose}>
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: 'white', padding: '20px', outline: 'none', borderRadius: '10px' }}>
                <div style={{ position: 'absolute', top: 0, right: 0, padding: '5px' }}>
                    <img style={{ width: '40px', cursor: 'pointer' }} src={cross} alt="Close Icon" onClick={onClose} />
                </div>
                <div style={{ padding: "30px", width:"400px" }}>
                    <Card>
                        <label style={{ color: "red", display: "flex", justifyContent: "center" }}>Missing Fields</label>
                        {/* Map over the errorMessages array and display each error message on a new line */}
                        {errorMessages.map((message, index) => (
                            <div key={index}>{message}</div>
                        ))}
                        <label style={{ color: "red", display: "flex", justifyContent: "center" }}>Note : These fields should not be empty</label>
                    </Card>
                </div>
            </div>
        </Modal>
    );
};

// Define PropTypes for the component
interface ErrorDialogProps {
    open: boolean;
    onClose: () => void;
    errorMessage: string; // Define the prop type for the error message
}




export default ErrorDialog;
